import React from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import { confirm } from 'util/confirm';
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import getUserByToken from 'controllers/user/getUserByToken'
import { connect } from 'react-redux';
import { browserHistory } from 'react-router'
import locale from './locale'
import "./Modal.scss";

const mapStateToProps = (state) => ({
  user: state.user,
})

const mapDispatchToProps = dispatch => {
  return {
  };
};

class ModalBody extends React.Component {

  constructor(props){
    super(props);

    this.state = {
    }

  }

	render() {
		const {show, proceed, dismiss, cancel, user} = this.props;

		return (
			<Modal
				className='media-center-modal'
				hasHeader={true}
        hasFooter={true}
				headerTitle={__("Media Center", locale)}
        fixedWidth={'90%'}
        contentHeight={500}

        onCloseModalClick={dismiss}

        footerType="grey"
        footerButtons={[
          {
            title: __('Complete', 'appwrapper'),
            className: 'btn btn-primary pull-right',
            isDisabled: ()=>{
            },
            onClick: ()=>{
              proceed(this.formData)
            }
          },
        ]}
        // footerCustomContent={this.footerContent()}
        isShowingModal={show} >
        <ModalContent
          {...this.props}
          onFormChange={(stateFromModalContent)=>{this.formData = stateFromModalContent;}}
        />
			</Modal>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(confirmable(ModalBody));



// WEBPACK FOOTER //
// ./src/template/Modals/MediaCenter/ModalBody.js